var _defs, _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathBathtubCleanSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "filled",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}.cls-1,.cls-2,.cls-3{stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2{fill:#bdc3c7;}.cls-3{fill:none;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62,32a5.9737,5.9737,0,0,1-1.2085,3.6119A23.8682,23.8682,0,0,0,56,50h0a6,6,0,0,1-6,6H18a6,6,0,0,1-6-6h0A23.8682,23.8682,0,0,0,7.2085,35.6119,5.9737,5.9737,0,0,1,6,32Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 4,
    transform: "translate(92 116) rotate(-180)",
    width: 4,
    x: 44,
    y: 56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 4,
    width: 4,
    x: 20,
    y: 56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,12V8a4,4,0,0,1,4-4h0a4,4,0,0,1,4,4V32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43,16h8a4,4,0,0,0-4-4h0a3.74,3.74,0,0,0-4,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathBathtubCleanSvgrepoCom);
export default __webpack_public_path__ + "static/media/bath-bathtub-clean-svgrepo-com.24b87881e47890e0db352bb6b4021d27.svg";
export { ForwardRef as ReactComponent };